import { render } from "./OutstandingPoReport.vue?vue&type=template&id=24220730&scoped=true"
import script from "./OutstandingPoReport.vue?vue&type=script&lang=js"
export * from "./OutstandingPoReport.vue?vue&type=script&lang=js"

import "./OutstandingPoReport.vue?vue&type=style&index=0&id=24220730&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24220730"]])

export default __exports__